// const baseUrl = "https://sportingbharat.com/SV/dev/backend/api";
const baseUrl = "https://sah.sportzvillage.com/dev/backend/api";
// const baseUrl = "http://localhost:8000/api";
export const apiBaseUrl = process.env.REACT_APP_SVO2_BASE_URL || "https://dev-api-svo.sportzvillage.com/api";

export default baseUrl;